export const CLOSING_TAG_DELIMITER = '}';
